import { prefectures } from '@gyym/sdk'

export const prefectureOptions = prefectures.map(({ id, name }) => ({
  value: id,
  label: name,
}))
